import React from "react"
import Util from "../../../util/util"
import API from "../../../data/bd"
const echarts = window.echarts

export default class CarChart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lastHour: props.lastHour,
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let { lastHour, selectedShop } = nextProps
    if (
      lastHour !== prevState.lastHour ||
      selectedShop !== prevState.selectedShop
    ) {
      return {
        lastHour,
        selectedShop,
      }
    }
    return null
  }
  componentDidMount() {
    // 基于准备好的dom，初始化echarts实例
    var mc = (this.myChart = echarts.init(this.refs.$con))
    var op = {
      // title: {
      //   text: "车流量",
      //   textStyle: {
      //     fontSize: 14,
      //     color: "rgb(67,148,190)",
      //   },
      // },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          label: {
            backgroundColor: "#283b56",
          },
        },
      },
      grid: {
        left: "1%",
        right: "1%",
        bottom: "1%",
        top: 30,
        containLabel: true,
      },
      legend: {
        //图例组件，颜色和名字
        right: "3%",
        top: 5,
        itemGap: 16,
        itemWidth: 18,
        itemHeight: 10,
        data: [
          {
            name: "星巴克",
            //icon:'image://../wwwroot/js/url2.png', //路径
          },
          {
            name: "正大百货",
          },
          {
            name: "星期五餐厅",
          },
        ],
        textStyle: {
          color: "#a8aab0",
          fontStyle: "normal",
          fontFamily: "微软雅黑",
          fontSize: 12,
        },
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: true, //坐标轴两边留白
          data: [],
          axisLabel: {
            //坐标轴刻度标签的相关设置。
            interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
            // margin: 15,
            formatter: function(val) {
              return val.split(" ").join("\n")
            },
            textStyle: {
              color: "#078ceb",
              fontStyle: "normal",
              fontFamily: "微软雅黑",
              fontSize: 12,
            },
          },
          axisTick: {
            //坐标轴刻度相关设置。
            show: false,
          },
          axisLine: {
            //坐标轴轴线相关设置
            lineStyle: {
              color: "#fff",
              opacity: 0.2,
            },
          },
          splitLine: {
            //坐标轴在 grid 区域中的分隔线。
            show: false,
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "zon",
          splitNumber: 5,
          axisLabel: {
            textStyle: {
              color: "#a8aab0",
              fontStyle: "normal",
              fontFamily: "微软雅黑",
              fontSize: 12,
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#fff"],
              opacity: 0.06,
            },
          },
        },
      ],
      series: [
        {
          name: "",
          type: "bar",
          data: [],
          barWidth: 15,
          barGap: 0.2, //柱间距离
          label: {
            //图形上的文本标签
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "rgba(104, 253, 255, 0.7)",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 10,
              },
              distance: 0,
            },
          },
          itemStyle: {
            //图形样式
            normal: {
              barBorderRadius: [5, 5, 0, 0],
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 1,
                    color: "rgb(6, 74, 235)",
                  },
                  {
                    offset: 1,
                    color: "rgb(7, 140, 235)",
                  },
                  {
                    offset: 0.31,
                    color: "rgb(0, 208, 208)",
                  },
                  {
                    offset: 0.15,
                    color: "rgb(0, 208, 208)",
                  },
                  {
                    offset: 0,
                    color: "rgb(104, 253, 255)",
                  },
                ],
                false
              ),
              opacity: 1,
            },
          },
        },
        {
          name: "",
          type: "bar",
          data: [],
          barWidth: 15,
          barGap: 0.2, //柱间距离
          label: {
            //图形上的文本标签
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "rgba(253, 200, 106, 0.7)",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 10,
              },
              distance: 0,
            },
          },
          itemStyle: {
            //图形样式
            normal: {
              barBorderRadius: [5, 5, 0, 0],
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 1,
                    color: "rgb(127, 128, 225)",
                  },
                  {
                    offset: 0.9,
                    color: "rgb(72, 73, 181)",
                  },
                  {
                    offset: 0.25,
                    color: "rgb(226, 99, 74)",
                  },
                  {
                    offset: 0,
                    color: "rgb(253, 200, 106)",
                  },
                ],
                false
              ),
              opacity: 1,
            },
          },
        },
        {
          name: "",
          type: "bar",

          data: [],
          barWidth: 15,
          barGap: 0.2, //柱间距离
          label: {
            //图形上的文本标签
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "rgba(235, 180, 199, 0.7)",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 10,
              },
              distance: 0,
            },
          },
          itemStyle: {
            //图形样式
            normal: {
              barBorderRadius: [5, 5, 0, 0],
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 1,
                    color: "rgb(235, 57, 111)",
                  },
                  {
                    offset: 1,
                    color: "rgb(235, 126, 153)",
                  },
                  {
                    offset: 0.25,
                    color: "rgb(235, 126, 153)",
                  },
                  {
                    offset: 0,
                    color: "rgb(235, 180, 199)",
                  },
                ],
                false
              ),
              opacity: 1,
            },
          },
        },
      ],
    }
    mc.setOption(op)
    Util.registerChartsResize(mc)
    this.refreshChart()
  }
  componentWillUnmount() {
    Util.destroyCharts(this.myChart)
  }
  refreshChart() {
    let { lastHour, selectedShop } = this.state
    let hours = []
    let mc = this.myChart
    let op = mc.getOption()
    for (let i = 3; i >= 0; i--) {
      let h = (lastHour - i + 24) % 24
      hours.push(h)
    }
    op.xAxis[0].data = hours.map(h => h + ":00")
    API.getCarFlowData(hours).then(series => {
      op.series.forEach((s, i) => {
        s.name = series[i].name
        s.data = series[i].values
        s.itemStyle.normal.opacity = 1
        if (selectedShop && selectedShop.id !== i) {
          s.itemStyle.normal.opacity = 0.2
        }
      })
      mc.setOption(op)
    })
  }
  componentDidUpdate() {
    this.refreshChart()
  }

  render() {
    return <div ref="$con" style={{ height: "100%" }} />
  }
}
